interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function getPages(current: number, total: number): (number | string)[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push('...');
  pages.push(total);
  return pages;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = getPages(current, totalPages);

  const baseBtn =
    'flex h-9 min-w-9 items-center justify-center rounded-md border px-2 text-sm transition-colors cursor-pointer';

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((page, i) =>
        typeof page === 'number' ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`${baseBtn} ${
              page === current
                ? 'border-primary-500 bg-primary-500 text-background-50'
                : 'border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600'
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`ellipsis-${i}`} className="px-1 text-foreground-400">
            {page}
          </span>
        )
      )}

      <button
        type="button"
        disabled={current === totalPages}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </div>
  );
}